import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldSwitch, FlexBox, Slider } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';
import { useUpdateEffect } from 'react-use';
import { convertMinutesToAbsoluteTime, convertToHumanRelativeTime, convertToTotalMinutesIntoDay, } from 'components/powerFlowShared/helpers/timeHelpers';
import styles from './day.module.scss';
const DEFAULT_OPEN_MINS = 540;
const DEFAULT_OPEN_ABS = convertMinutesToAbsoluteTime(DEFAULT_OPEN_MINS);
const DEFAULT_CLOSE_MINS = 1050;
const DEFAULT_CLOSE_ABS = convertMinutesToAbsoluteTime(DEFAULT_CLOSE_MINS);
export function Day({ day, index, onDayChange }) {
    const { intervals } = day;
    const dayInterval = intervals[0];
    const absoluteTimeOpen = (dayInterval === null || dayInterval === void 0 ? void 0 : dayInterval.open) || DEFAULT_OPEN_ABS;
    const absoluteTimeClose = (dayInterval === null || dayInterval === void 0 ? void 0 : dayInterval.close) || DEFAULT_CLOSE_ABS;
    const [isOpen, setIsOpen] = useState(!!dayInterval);
    const [time, setTime] = useState({
        absoluteTimeOpen,
        absoluteTimeClose,
    });
    const onIsOpenChange = useCallback(() => {
        setIsOpen((isOpen) => !isOpen);
    }, [setIsOpen]);
    const onSliderChange = useCallback(([open, close]) => {
        const absoluteTimeOpen = convertMinutesToAbsoluteTime(open);
        const absoluteTimeClose = convertMinutesToAbsoluteTime(close);
        setTime({ absoluteTimeOpen, absoluteTimeClose });
    }, [setTime]);
    useUpdateEffect(() => {
        const { absoluteTimeOpen: open, absoluteTimeClose: close } = time;
        const interval = isOpen ? [{ open, close }] : [];
        onDayChange(index, interval);
    }, [index, isOpen, onDayChange, time]);
    const weekDayName = new Date(day.date).toLocaleString(['en-GB'], {
        weekday: 'long',
        timeZone: 'UTC',
    });
    const sliderValues = [
        time.absoluteTimeOpen
            ? convertToTotalMinutesIntoDay(time.absoluteTimeOpen)
            : DEFAULT_OPEN_MINS,
        time.absoluteTimeClose
            ? convertToTotalMinutesIntoDay(time.absoluteTimeClose)
            : DEFAULT_CLOSE_MINS,
    ];
    return (_jsxs(FlexBox, Object.assign({ flexDirection: "column", className: styles.root }, { children: [_jsxs(FlexBox, Object.assign({ justifyContent: "space-between", alignItems: "center", className: styles.weekDayWrapper }, { children: [_jsx("div", Object.assign({ className: styles.weekDayName }, { children: weekDayName })), _jsx(FieldSwitch, { className: styles.fieldSwitch, input: {
                            checked: isOpen,
                            name: 'active',
                            value: 'active',
                            onChange: onIsOpenChange,
                        } })] })), _jsxs(FlexBox, Object.assign({ justifyContent: "space-between", alignItems: "center", className: styles.timeWrapper }, { children: [_jsx("div", Object.assign({ className: styles.timeValue }, { children: isOpen
                            ? convertToHumanRelativeTime(time.absoluteTimeOpen)
                            : 'Closed' })), isOpen && (_jsx("div", Object.assign({ className: styles.sliderWrapper }, { children: _jsx(Slider, { min: 0, max: 1439, step: 15, value: sliderValues, onChange: onSliderChange, hideAnnotations: true }) }))), isOpen && time.absoluteTimeClose && (_jsx("div", Object.assign({ className: styles.timeValue }, { children: convertToHumanRelativeTime(time.absoluteTimeClose) })))] }))] })));
}
